module.exports = __webpack_public_path__ + "img/cosede.ed31b41c.png";